<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router/composables'
import copyToClipBoard from '@utils/copy-to-clipboard'
import SocialShare from '@components/social-share'
import { useStore } from '@composables/use-store'
import { useMessages } from '@composables/use-messages'

const props = defineProps({
    artist: {
        type: Object,
        default: () => {},
    },
    hasViewArtistOption: {
        type: Boolean,
        default: true,
    },
})

const store = useStore()
const router = useRouter()
const getMessageText = useMessages()

const url = computed(() => {
    const { protocol, hostname, port } = window.location
    const href = router.resolve({
        name: 'artist',
        params: { artistUrl: props.artist.url, id: props.artist.id },
    }).href
    return `${protocol}//${hostname}${port ? ':' + port : ''}${href}`
})

function copyLinkToClipBoard() {
    copyToClipBoard(url.value)
    store.dispatch('appearance/handleNotification', {
        message: getMessageText('LINK_COPIED_CLIPBOARD'),
        type: 'success',
    })
}
</script>

<template>
    <ul class="artist-options">
        <li
            v-if="hasViewArtistOption"
            class="artist-options-item"
            @click="router.push({ name: 'artist', params: { artistUrl: artist.url, id: artist.id } })"
        >
            <BaseButton
                icon="eye"
                size="medium"
                button-type="transparent"
                @click="() => {}"
            >&nbsp; View Artist</BaseButton>
        </li>
        <div
            v-if="hasViewArtistOption"
            class="separator"
        />

        <li class="artist-options-item">
            <BaseFavourites
                v-if="artist"
                :artist="artist"
                size="medium"
                button-type="transparent"
                icon-main="user-minus"
                icon-alt="user-plus"
            >
                <span slot="main">Follow Artist</span>
                <span slot="alt">Following</span>
            </BaseFavourites>
        </li>
        <h6 class="share-title">Share</h6>
        <div class="separator" />
        <li class="artist-options-item">
            <BaseButton
                icon="facebook"
                size="medium"
                button-type="transparent"
            >
                <SocialShare
                    :url="url"
                    type="facebook"
                />
            </BaseButton>
        </li>
        <li class="artist-options-item">
            <BaseButton
                icon="twitter"
                size="medium"
                button-type="transparent"
            >
                <SocialShare
                    :url="url"
                    :custom-text="`${artist.title} on @friskyradio #feelinfrisky`"
                    type="twitter"
                />
            </BaseButton>
        </li>
        <li
            class="artist-options-item"
            @click="copyLinkToClipBoard"
        >
            <BaseButton
                icon="link"
                size="medium"
                button-type="transparent"
                @click="() => {}"
            >&nbsp;Copy Artist link</BaseButton>
        </li>
    </ul>
</template>

<style lang="scss" scoped>
@import '@design';

.artist-options {
    padding: 0;
    margin: 0;
    text-align: left;
    list-style: none;

    &-item {
        display: flex;
        align-items: center;
        height: 44px;
        padding: 0 $s-m;
    }
}

.separator {
    position: relative;
    display: block;
    width: 100%;
    height: 1px;
    background: $c-mine-shaft;
}

.share-title {
    @extend %contentTitleM;

    margin: $s-s 0 $s-s $s-xl;
}
</style>
